import React, { useContext, useState } from 'react';
import { Button, Modal } from '@solvhealth/jigsaw-v1';
import { analyticsTrackEvent } from '~/core/analytics';
import { CLINIC_DETAIL_PAGE_VIEW_OTHER_SERVICES } from '~/core/analytics/events';
import { isMobile, useUserAgent } from '~/core/util/device';
import ServicesList, { getDisplayServices } from '~/components/ServicesList/ServicesList';
import { LocationContext } from '~/components/ClinicDetailPageFlexible/ContextProviders';
import dataTestIds from '~/test/test-ids';

const CDPOtherServices = () => {
  const { location } = useContext(LocationContext);
  const { servicesObj: locationServices } = location;
  const userAgent = useUserAgent();
  const [showModal, setShowModal] = useState(false);

  const displayModal = () => {
    const trackingProperties = {
      locationId: location.id,
      uclId: location.uclId,
    };
    analyticsTrackEvent(CLINIC_DETAIL_PAGE_VIEW_OTHER_SERVICES, trackingProperties);
    setShowModal(true);
  };

  const displayServices = getDisplayServices(locationServices as any);

  return displayServices.length > 0 ? (
    <div>
      <Modal
        alignment="center"
        onClose={() => {
          setShowModal(false);
        }}
        open={showModal}
        variant="long"
      >
        <ServicesList locationPhone={location.phone} services={location.servicesObj as any} />
      </Modal>
      <Button
        data-testid={dataTestIds.cdp.allServicesBtn}
        fullWidth={!!isMobile(userAgent)}
        onClick={displayModal}
        size="medium"
        variant="outlined"
      >
        View other services
      </Button>
    </div>
  ) : null;
};

export default CDPOtherServices;
